import { mapActions, mapGetters } from 'vuex'
import { email, minLength, required } from 'vuelidate/lib/validators'
import PhoneMaskInput from 'vue-phone-mask-input'

import { parsePhoneNumberFromString } from 'libphonenumber-js'
import validation from '@/mixins/validation'

export default {
  name: 'user-data',

  data() {
    return {
      payload: {
        phone_country: '',
        phone: '',
        email: '',
      },
      isEdit: false,
      validationErrors: {},
    }
  },
  mixins: [validation],
  validations: {
    payload: {
      phone: {
        required,
        minLength: minLength(12),
      },
      email: {
        email,
        required,
      },
    },
  },
  components: {
    PhoneMaskInput,
  },
  mounted() {
    setTimeout(() => {
      this.$refs.fakeInput.focus()
    }, 100)
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      updateUserLoading: 'profile/updateUserLoading',
    }),
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        required: 'validationRequired',
        email: 'validationEmail',
      })
    },
    phoneErrors() {
      return this.computeErrors('payload', 'phone', {
        required: 'validationRequired',
        minLength: { message: 'minimumNumberOfCharacters', count: 13 },
      })
    },
  },
  watch: {
    user(newVal) {
      if (newVal) {
        if (this.user) this.setUserInfo()
      }
    },
  },
  created() {
    if (this.user) this.setUserInfo()
  },
  methods: {
    ...mapActions({
      updateUserData: 'profile/UPDATE_USER_DATA',
    }),
    setUserInfo() {
      this.payload.phone = this.user.phone
      this.payload.email = this.user.email
    },
    resetForm() {
      this.isEdit = false
      this.$v.$reset()
      this.setUserInfo()
    },
    update() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let parsedNumber = ''

        try {
          const phone = this.payload.phone
          if (phone) {
            parsedNumber = parsePhoneNumberFromString(phone.startsWith('+') ? phone : '+' + phone)
          }
        } catch (error) {
          console.error('Error parsing phone number:', error)
          parsedNumber = ''
        }

        if (parsedNumber) {
          this.payload.phone_country = parsedNumber.country
        } else {
          this.payload.phone_country = ''
        }

        this.updateUserData(this.payload)
          .then(() => {
            this.$toasted.success(this.$t('successResetContact'))
            this.isEdit = false
          })
          .catch((error) => {
            this.$toasted.error(error.data.message)
          })
      }
    },
  },
}
